import { I2cSpinner } from "@webcomponents/i2cwebcomponents/dist/react";
import "./Loader.scss";

export const OverlayLoader = ({
  size = "xxl",
  spinner = "dual-shade",
  hideSpinner = false,
  style = {},
}) => {
  function adjustLoaderHeight() {
    const loader = document.getElementById("loadingSpinner");
    const bodyHeight = document.body.scrollHeight;
    // if (loader) loader.style.height = `${bodyHeight}px`;
  }

  // Call the function initially to set the loader height
  adjustLoaderHeight();

  // Optionally, call the adjustLoaderHeight function on window resize to update the loader height
  window.addEventListener("resize", adjustLoaderHeight);

  return (
    <>
      <div style={style} className="loading-spinner" id="loadingSpinner">
        {!hideSpinner && (
          <I2cSpinner size={size} label="Loading..." spinner={spinner} />
        )}
      </div>
    </>
  );
};
